import React from 'react';
import {
  Container,
  Card,
  Front,
  Back,
  Lower,
  Shiny,
  LogoContainer,
  Logo,
  Bar,
  Number,
  Name,
  Expiration,
  Cvc,
} from './styles';
import { CreditCardHelper } from '../../utils/creditCardHelper';


interface ReactCreditCardProps {
  number?: string;
  name?: string;
  expiration?: string;
  cvc?: string;
  focused?: string;
  type?: string;
  placeholderName?: string;
  expirationBefore?: string;
  expirationAfter?: string;
  hasShadow?: boolean;
  hasRadialGradient?: boolean;
}

const ReactCreditCard: React.FC<ReactCreditCardProps> = (props) => {
  const cardInfo = CreditCardHelper.getCardInfo({
    number: props.number,
    type: props.type
  });
  const isFlipped = props.focused === 'cvc';
  const logo = CreditCardHelper.getLogoSrc(cardInfo.brand);

  return (
    <Container>
      <Card
        isFlipped={isFlipped}
        brand={cardInfo.brand}
        hasShadow={props.hasShadow}
        hasRadialGradient={props.hasRadialGradient}
      >
        <Front brand={cardInfo.brand} hasRadialGradient={props.hasRadialGradient}>
          <Lower>
            <Shiny />
            {logo && (
              <LogoContainer isPositionAbsolute={true} height="35" width="50">
                <Logo src={logo} alt={cardInfo.brand} />
              </LogoContainer>
            )}
            <Number focused={props.focused === 'number'}>
              {CreditCardHelper.formatNumber(props.number, cardInfo)}
            </Number>
            <Name focused={props.focused === 'name'}>
              {!props.name ? props.placeholderName : props.name}
            </Name>
            <Expiration
              focused={props.focused === 'expiration'}
              data-before={props.expirationBefore}
              data-after={props.expirationAfter}
            >
              {CreditCardHelper.formatExpiration(props.expiration)}
            </Expiration>
          </Lower>
        </Front>
        <Back brand={cardInfo.brand} hasRadialGradient={props.hasRadialGradient}>
          <Bar />
          <Cvc focused={props.focused === 'cvc'} isBack>
            {CreditCardHelper.formatCvc(props.cvc, cardInfo.cvcLength)}
          </Cvc>
        </Back>
      </Card>
    </Container>
  );
};

ReactCreditCard.defaultProps = {
  placeholderName: 'FULL NAME',
  expirationBefore: 'month/year',
  expirationAfter: 'valid\nthru',
  hasRadialGradient: false,
  hasShadow: false,
};

export default ReactCreditCard;
